import { InjectionToken } from '@angular/core';

export const PartnerToken = new InjectionToken('PARTNER');
